import { Loader2 } from 'lucide-react'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

type StepConnectProps = {
  onConnect: (provider: 'google' | 'microsoft') => void
  isLoading: boolean
}

export function StepConnect({ onConnect, isLoading }: StepConnectProps) {
  return (
    <div className="space-y-8">
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold tracking-tight">
          Connect Your Email Account
        </h1>
        <p className="text-muted-foreground max-w-md mx-auto">
          Choose your email provider to get started. We&apos;ll only request the
          permissions needed to read and manage your emails.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 max-w-lg mx-auto">
        <button
          type="button"
          disabled={isLoading}
          onClick={() => onConnect('google')}
          className="rounded-xl text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        >
          <Card className="h-full hover:border-primary transition-colors">
            <CardHeader className="text-center pb-2">
              <div className="mx-auto mb-2">
                <svg className="h-12 w-12" viewBox="0 0 24 24">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
              </div>
              <CardTitle className="text-base">Gmail</CardTitle>
            </CardHeader>
            <CardContent className="text-center">
              <CardDescription>Connect your Google account</CardDescription>
            </CardContent>
          </Card>
        </button>

        <button
          type="button"
          disabled={isLoading}
          onClick={() => onConnect('microsoft')}
          className="rounded-xl text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        >
          <Card className="h-full hover:border-primary transition-colors">
            <CardHeader className="text-center pb-2">
              <div className="mx-auto mb-2">
                <svg className="h-12 w-12" viewBox="0 0 24 24">
                  <path fill="#F25022" d="M1 1h10v10H1z" />
                  <path fill="#00A4EF" d="M1 13h10v10H1z" />
                  <path fill="#7FBA00" d="M13 1h10v10H13z" />
                  <path fill="#FFB900" d="M13 13h10v10H13z" />
                </svg>
              </div>
              <CardTitle className="text-base">Outlook</CardTitle>
            </CardHeader>
            <CardContent className="text-center">
              <CardDescription>Connect your Microsoft account</CardDescription>
            </CardContent>
          </Card>
        </button>
      </div>

      {isLoading && (
        <div className="flex justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      )}
    </div>
  )
}
